export default {
  menu: {
    dashboard: "Tableau de bord",
    projects: "Projets",
    architectures: "Architectures",
    templates: "Modèles",
    cloudServices: "Services Cloud",
    finops: "FinOps",
    monitoring: "Monitoring",
    gettingStarted: "Guide de démarrage",
    settings: "Paramètres",
    help: "Aide",
    documentation: "Documentation",
    profile: "Profil",
    logout: "Déconnexion"
  },
  sidebar: {
    overview: "Vue d'ensemble",
    myProjects: "Mes projets",
    recentArchitectures: "Architectures récentes",
    favorites: "Favoris",
    shared: "Partagés",
    archived: "Archivés"
  }
};
